{
  "version": 1,
  "asset_id": "a89e5f97-ee98-4dcd-9aae-d297e69bf39b",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/a89e5f97-ee98-4dcd-9aae-d297e69bf39b/destination-roofing-crew-citrus-county-fl-1024.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/a89e5f97-ee98-4dcd-9aae-d297e69bf39b/destination-roofing-crew-citrus-county-fl-1024.webp",
  "original_filename": "destination-roofing-crew-citrus-county-fl-1024.webp",
  "size": 92444,
  "content_type": "image/webp",
  "created_at": "2026-07-21T15:42:33Z"
}
